export default {
    data () {
        return {
            interval: null,
            pause: false,
            seconds: 60
        }
    },
    methods: {
        startInterval() {
            this.interval = setTimeout(() => {
                if (!this.pause) {
                    this.tick()
                }
                this.startInterval()
            }, this.seconds * 1000)
        },
        clearInterval() {
            clearTimeout(this.interval)
        },
        tick() { }
    },
    mounted () {
        this.startInterval()
    },
    beforeDestroy () {
        this.clearInterval()
    }
}
